
import { createSlice } from "@reduxjs/toolkit";
// import {
//   // getTeacherBaselineThunk,
//   getTeacherBaselineFlnThunkSkill,
//   getTeacherBaselinePgeThunkSkill,
//   getTeacherBaselineEceThunkSkill,
// } from "./FlnSkillsThunk";

import {
  // getTeacherBaselineThunk,
  getTeacherBaselineFlnThunkSkill,
  getTeacherBaselinePgeThunkSkill,
  getTeacherBaselineEceThunkSkill,
} from "../FlnSkill/FlnSkillThunk";

const initialState = {
  data: [],
  skill: [],
  loading: false,
  status: "",
  message: "",
  skillId: "",
  skillName: "",
  usertype: "fellow",
  activityType: "",
  language: "od",
  program: "",
  clas: 0,
  level: 0,
  subject: "",
  disable_content_button: true,
};

const FlnSkillsSlice = createSlice({
  name: "flnskillsslice",
  initialState,
  reducers: {
    language_change_skill: (state, action) => {
      state.language = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    usertype_change_skill: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    activityType_change_skill: (state, action) => {
      state.activityType = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    program_change_skill: (state, action) => {
      state.program = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    clas_change_skill: (state, action) => {
      state.clas = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    level_change_skill: (state, action) => {
      state.level = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    subject_change_skill: (state, action) => {
      state.subject = action.payload;
      state.data = [];
      state.skillId = "";
      state.skillName = "";
      state.disable_content_button = true;
    },
    clear_data_skill: (state) => {
      state.skill = [];
      state.loading = false;
      state.status = "";
      state.message = "";
    },
  },
  extraReducers: {
    [getTeacherBaselineFlnThunkSkill.pending]: (state, action) => {
      state.skill = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getTeacherBaselineFlnThunkSkill.fulfilled]: (state, action) => {
      state.skill = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getTeacherBaselineFlnThunkSkill.rejected]: (state, action) => {
      state.skill = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [getTeacherBaselinePgeThunkSkill.pending]: (state, action) => {
      state.skill = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getTeacherBaselinePgeThunkSkill.fulfilled]: (state, action) => {
      state.skill = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getTeacherBaselinePgeThunkSkill.rejected]: (state, action) => {
      state.skill = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [getTeacherBaselineEceThunkSkill.pending]: (state, action) => {
      state.skill = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getTeacherBaselineEceThunkSkill.fulfilled]: (state, action) => {
      state.skill = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getTeacherBaselineEceThunkSkill.rejected]: (state, action) => {
      state.skill = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    // [getTeacherBaselineCommunityThunk.pending]: (state, action) => {
    //   state.data = [];
    //   state.loading = true;
    //   state.status = action.meta.requestStatus;
    //   state.message = "loading";
    // },
    // [getTeacherBaselineCommunityThunk.fulfilled]: (state, action) => {
    //   state.data = action.payload;
    //   state.loading = false;
    //   state.status = action.meta.requestStatus;
    //   state.message = "success";
    // },
    // [getTeacherBaselineCommunityThunk.rejected]: (state, action) => {
    //   state.data = [];
    //   state.loading = false;
    //   state.status = action.meta.requestStatus;
    //   state.message = action.error.message;
    // },
    // [createTeacherBaselineThunk.pending]: (state, action) => {
    //   state.data = [];
    //   state.loading = true;
    //   state.status = action.meta.requestStatus;
    //   state.message = "loading";
    // },
    // [createTeacherBaselineThunk.fulfilled]: (state, action) => {
    //   state.data = action.payload;
    //   state.loading = false;
    //   state.status = action.meta.requestStatus;
    //   state.message = "success";
    // },
    // [createTeacherBaselineThunk.rejected]: (state, action) => {
    //   state.data = [];
    //   state.loading = false;
    //   state.status = action.meta.requestStatus;
    //   state.message = action.error.message;
    // },

    // [updateTeacherBaselineThunk.pending]: (state, action) => {
    //   state.data = [];
    //   state.loading = true;
    //   state.status = action.meta.requestStatus;
    //   state.message = "loading";
    // },
    // [updateTeacherBaselineThunk.fulfilled]: (state, action) => {
    //   state.data = action.payload;
    //   state.loading = false;
    //   state.status = action.meta.requestStatus;
    //   state.message = "success";
    // },
    // [updateTeacherBaselineThunk.rejected]: (state, action) => {
    //   state.data = [];
    //   state.loading = false;
    //   state.status = action.meta.requestStatus;
    //   state.message = action.error.message;
    // },
  },
});

export const {
  usertype_change_skill,
  activityType_change_skill,
  language_change_skill,
  program_change_skill,
  clas_change_skill,
  level_change_skill,
  subject_change_skill,
  clear_data_skill,
} = FlnSkillsSlice.actions;

export default FlnSkillsSlice.reducer;
